import axios from "axios";
import { clienteInfo, getDatosUsuariosLocalStorag, getUsuario } from "utils/DatosUsuarioLocalStorag";
import { ListarLocalidad } from "utils/LocalidadesQuery";
import { boleteriaAxios } from "utils/index";

// Antes mandaba x-user-id/x-user-perfil, que el navegador arma solo (sin firmar) y
// cualquiera podia falsificar. Ahora manda el JWT real que ya se guarda al loguearse.
const getHeadersWithUserContext = () => {
    return {
        'Content-Type': 'application/json',
        'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ==',
        'Authorization': `Bearer ${getUsuario()}`,
    };
}

export const Actualisardescripcionevento = async () => {
    try {
        let { data } = axios.get("https://api.t-ickets.com/ms_login/api/v1/actualisar_descripcion_evento", {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='

            }
        })
        return data
    } catch (error) {
        return error
    }
}
// Obtiene un evento por su codigoEvento sin importar su estado.
// Se usa para el flujo de compra "solo por link" (eventos en PROCESO que no
// aparecen en los listados publicos de ACTIVO/PROXIMO/CANCELADO).
export const ObtenerEventoPorCodigo = async (codigoEvento) => {
    try {
        const { data } = await axios.get("https://api.t-ickets.com/ms_login/evento_por_codigo/" + codigoEvento, {
            headers: getHeadersWithUserContext()
        })
        return data
    } catch (error) {
        return { success: false, message: "Error al obtener el evento", data: null }
    }
}
export const ListarEventosFinalizados = async () => {
    try {
        const { data } = await axios.get("https://api.t-ickets.com/ms_login/listareventos/CANCELADO/", {
            headers: getHeadersWithUserContext()
        })
        return data.data
    } catch (error) {
        return error;

    }
}
const ListarEventosLis = async () => {
    try {
        const { data } = await axios.get("https://api.t-ickets.com/ms_login/listareventos/ACTIVO/", {
            headers: getHeadersWithUserContext()
        })
        const datas = await axios.get("https://api.t-ickets.com/ms_login/listareventos/PROCESO/", {
            headers: getHeadersWithUserContext()
        })
        const event = await axios.get("https://api.t-ickets.com/ms_login/listareventos/CANCELADO/", {
            headers: getHeadersWithUserContext()
        })
        return [...data.data, ...datas.data.data, ...event.data.data]
    } catch (error) {
        return error;

    }
}

const traerprecios = async (path) => {
    try {
        let { data } = await axios.get(path, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        // Si esta ruta especifica falla (algunos eventos de prueba no tienen
        // localidades/precios configurados y el backend responde 500 en vez
        // de un array vacio), se devuelve [] en vez de el error crudo -- antes
        // "return error" hacia que mas abajo, en ListaPreciosEvent, e.Precios
        // terminara siendo un objeto Error en vez de un array, y el
        // e.Precios.map() de la siguiente linea reventara TODA la funcion
        // (incluyendo los eventos que si tenian precios validos).
        return Array.isArray(data?.data) ? data.data : []
    } catch (error) {
        return []
    }

}

// ListaPreciosEvent hace 1 peticion HTTP POR EVENTO (ListaPreciosLocalidades)
// para precalentar el cache "PreciosLocalidad" que leen otras pantallas
// (Aprobar, Detalleregistro, Informeventa, Suscritorid, columnasub -- ninguna
// de ellas vuelve a pedirlo, solo leen sessionStorage). El problema es que se
// llama SIN ninguna proteccion desde 4 paginas distintas (Dashboard, esta
// misma lista de Eventos, "Nuevo evento", la tienda publica) -- si el admin
// entra a Dashboard y de ahi a Eventos en un par de segundos, se repite TODO
// el trabajo (una peticion por cada evento, 2 veces seguidas) sin necesidad,
// porque el cache de la primera pasada seguia perfectamente valido.
// Este guard evita rehacer el trabajo si ya se corrio hace poco (o si ya hay
// una corrida en curso, para no duplicar si dos paginas lo llaman casi al
// mismo tiempo) -- el contenido y la forma de "PreciosLocalidad" no cambian,
// solo se genera con menos frecuencia.
const TTL_PRECIOS_MS = 3 * 60 * 1000 // 3 minutos
let ultimaCorridaPrecios = 0
let corridaPreciosEnCurso = null

export const ListaPreciosEvent = async () => {
    const ahora = Date.now()
    const cacheVigente = sessionStorage.getItem("PreciosLocalidad") != null
        && (ahora - ultimaCorridaPrecios) < TTL_PRECIOS_MS
    if (cacheVigente) return
    if (corridaPreciosEnCurso) return corridaPreciosEnCurso

    corridaPreciosEnCurso = (async () => {
        try {
            const resultado = await ListarEventosLis()
            if (!Array.isArray(resultado)) return
            let newarr = []
            const data = await Promise.all(
                resultado.map(async (e) => {
                    const info = await traerprecios("https://api.t-ickets.com/ms_login/ListaPreciosLocalidades/" + e.codigoEvento)
                    e.Precios = info
                    return e
                }))
            data.forEach((e) => {
                (e.Precios || []).forEach(f => newarr.push({ ...f }))
            })
            sessionStorage.setItem("PreciosLocalidad", JSON.stringify(newarr))
            ultimaCorridaPrecios = Date.now()
        } catch (error) {
            // Best-effort: si algo falla, las pantallas que leen
            // PreciosLocalidad simplemente ven el cache anterior (o vacio),
            // no se rompe la pagina que llamo a ListaPreciosEvent.
        } finally {
            corridaPreciosEnCurso = null
        }
    })()

    return corridaPreciosEnCurso
}
/*
export const Boleteria_canje = async (codigoEvento) => {
    try {
        let { data } = await boleteriaAxios.get("Boleteria/canje/" + codigoEvento)
        return data
    } catch (error) {
        return error
    }
}*/
/*
export const Boleteria_Boletos = async (codigoEvento) => {
    try {
        let { data } = await boleteriaAxios.get("Boleteria/boletos/" + codigoEvento)
        return data
    } catch (error) {
        return error
    }
}*//*
export const Boleteria_Nombre = async (nombre) => {
    try {
        let { data } = await boleteriaAxios.post("Boleteria/evento_valor", { "nombre": nombre })
        return data
    } catch (error) {
        return error
    }
}
export const Boleteria_medios = async (nombre) => {
    try {
        let { data } = await boleteriaAxios.post("Boleteria/evento_forma", { "nombre": nombre })
        return data
    } catch (error) {
        return error
    }
}*/
export const Boleteria_voucher = async (params) => {
    let ids = clienteInfo() != null ? clienteInfo().id : 0

    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(ids),
        ...params
    }
    try {
        let { data } = await boleteriaAxios.post("/Boleteria/voucher", parmspro)
    
        return data
    } catch (error) {
        return error
    }
}
export const Boleteria_password = async (params) => {
    let parmspro = {
        "cedula": params
    }
    try {
        let { data } = await boleteriaAxios.post("/Boleteria/resetpass", parmspro)
        return data
    } catch (error) {
        return error
    }
}